import { useMutation } from "@apollo/client/react";
import { create, show, useModal } from "@ebay/nice-modal-react";

import FlashContext from "components/FlashMessages/FlashContext";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";
import useTypedContext from "hooks/useTypedContext";

import { DELETE_PLUGIN, GET_PLUGINS } from "./gql";

type DeleteConfirmationProps = {
  name: string;
  id: string;
};

const DeleteConfirmation = create(function DeleteConfirmation({
  name,
  id,
}: DeleteConfirmationProps) {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const modal = useModal();

  const [deletePluginTemplate, { loading, data }] = useMutation(DELETE_PLUGIN, {
    refetchQueries: [GET_PLUGINS],
    awaitRefetchQueries: true,
    variables: { id },
  });

  const handleDeletePluginTemplate = () => {
    deletePluginTemplate()
      .then(() => {
        reportSuccess({
          message: `Plugin "${name}" was successfully deleted`,
        });
        modal.resolve();
        modal.hide();
      })
      .catch(onError);
  };

  return (
    <DeleteConfirmationModal
      title="Delete plugin template"
      onConfirm={handleDeletePluginTemplate}
      isLoading={loading}
      isDismissable={!loading && !data?.pluginDelete?.id}
    >
      <>
        <ConfirmationModalMessage>
          Are you sure you want to delete the plugin <strong>{name}</strong>?
        </ConfirmationModalMessage>
        <ConfirmationModalMessage>
          Deleting this plugin will <strong>not</strong> remove any labels attached to resources.
          Please ensure that you clean them up manually if necessary.
        </ConfirmationModalMessage>
      </>
    </DeleteConfirmationModal>
  );
});

export const showDeleteConfirmation = (props: DeleteConfirmationProps) =>
  show(DeleteConfirmation, props);
